import { DATADOG_PRIVACY_LEVELS } from 'constants/enums';

const MaskedHTMLParagraph = (props) => {
  return <p data-dd-privacy={DATADOG_PRIVACY_LEVELS.MASK}>{props.children}</p>;
};

const PickupAddressSummary = (props) => {
  const { pickupLocation } = props;

  return (
    <>
      <MaskedHTMLParagraph>
        {pickupLocation.partner_store}, {pickupLocation.location_name}
      </MaskedHTMLParagraph>
      <MaskedHTMLParagraph>{pickupLocation.address_line_1}</MaskedHTMLParagraph>
      <MaskedHTMLParagraph>
        {pickupLocation.city}, {pickupLocation.state}
      </MaskedHTMLParagraph>
      <MaskedHTMLParagraph>{pickupLocation.postal_code}</MaskedHTMLParagraph>
    </>
  );
};

export default PickupAddressSummary;
